let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2e4fM")).then(() => parcelRequire('ainWv'));